import { useState } from 'react';
import { api } from '../lib/api';

export function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    try { await api('/api/onboarding/forgot-password', { method: 'POST', body: JSON.stringify({ email }) }); }
    finally { setDone(true); setBusy(false); }
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <p className="qa-eyebrow mb-3 text-center">Reset password</p>
        <h1 className="qa-h1 text-center mb-6">
          Forgot your <span className="qa-italic-accent">password?</span>
        </h1>
        {done ? (
          <div className="qa-card p-8 text-center">
            <p>If an account exists for that email, we've sent reset instructions.</p>
            <p className="text-xs text-ink-mute mt-3">The link expires in 60 minutes.</p>
            <a href="/" className="btn-ghost mt-4 inline-block">← Back to sign in</a>
          </div>
        ) : (
          <form onSubmit={onSubmit} className="qa-card p-8 space-y-5">
            <div>
              <label className="qa-label">Email</label>
              <input type="email" required className="qa-input" value={email} onChange={e => setEmail(e.target.value)} />
            </div>
            <button className="btn-primary w-full" disabled={busy}>{busy ? 'Sending…' : 'Send reset link'}</button>
            <a href="/" className="block text-center text-xs text-ink-mute hover:text-rust">← Back to sign in</a>
          </form>
        )}
      </div>
    </div>
  );
}
